"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
class CustomFieldValue extends Parse.Object {
    constructor(attributes) {
        super('CustomFieldValue', attributes);
    }
    set customField(value) {
        this.set('customField', value);
    }
    get customField() {
        return this.get('customField');
    }
    set value(value) {
        this.set('value', value);
    }
    get value() {
        return this.get('value');
    }
    get retailer() { return this.get('retailer'); }
    set retailer(value) { this.set('retailer', value); }
}
exports.CustomFieldValue = CustomFieldValue;
Parse.Object.registerSubclass('CustomFieldValue', CustomFieldValue);
//# sourceMappingURL=CustomFieldValue.js.map